module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.missionAccess.community ? _vm.$t('mission.access.list.type.community') : _vm.$t('mission.access.list.type.user')))]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": _vm.routerLinkTarget
    }
  }, [_vm._v(_vm._s(_vm.missionAccess.community ? _vm.missionAccess.community.name : _vm.formatUserWithTag(_vm.missionAccess.user)))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3057c210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionAccessesRow.vue
// module id = 495
// module chunks = 0